import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { ApiError } from 'src/types/interfaces/api-error';

import { destinationGroupApi } from '../../api/lib/destination-group';
import { destinationGroupsKeys } from '../../api/query-keys/destination-groups';

import { hostsKeys } from '@/features/hosts/api/query-keys/hosts';

export const useAttachHostToDestinationGroup = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation(['common']);

  return useMutation({
    mutationFn: ({ hostId, destinationGroupId }: { hostId: number; destinationGroupId: number }) =>
      destinationGroupApi.addHostToDestinationGroup(destinationGroupId, hostId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: hostsKeys.all,
      });
      queryClient.invalidateQueries({
        queryKey: destinationGroupsKeys.all,
      });
      toast.success(t('common:popup.success'));

      onSuccess?.();
    },
    onError: (error: ApiError) => {
      toast.error(error?.response?.data?.message);
    },
  });
};
